<template>
	<div>
		<div class="mobile_only my_account_mobile">
			<section
				class="cat_in_top_banner cover"
				v-bind:style="'background-image:url(' + assets + '/upload/bn_account.jpg);'"
			>
				<div class="container">
					<div class="title25 center">איזור אישי</div>
				</div>
				<div class="bn_corner"></div>
			</section>
			<section class="my_account_mobile_in container">
				<div class="my_name_side">
					<div class="my_name_side_img">
						<account-svg />
					</div>
					<div class="my_name_side_tx">הי, {{ this.$store.state.userLoggedInfo.firstname }}</div>
				</div>
				<div class="cashback" v-if="!cashback.enabled"></div>
				<div class="side_nav">
					<div class="side_nav_link ease">
						<router-link :to="{ name: 'myaccount' }">
							החשבון שלי
							<ARROWL />
						</router-link>
					</div>
					<div class="side_nav_link ease">
						<router-link
							:to="{
								path: '/my-account/history',
								params: { state: 'history' },
							}"
						>
							היסטורית הזמנות
							<ARROWL />
						</router-link>
					</div>
					<div class="side_nav_link ease">
						<router-link :to="{ name: 'favorites' }">
							המועדפים שלי
							<ARROWL />
						</router-link>
					</div>
					<div class="side_nav_link ease">
						<router-link
							:to="{
								path: '/my-account/permenant',
								params: { state: 'order' },
							}"
						>
							הזמנה קבועה
							<span class="soon-sm" v-if="false">(בקרוב)</span>
							<ARROWL />
						</router-link>
					</div>
					<div class="side_nav_link here-logout ease">
						<a href="javascript:void(0);" @click="userLogout">
							{{ getLogoutText }}
							<log-out-svg />
						</a>
					</div>
				</div>
			</section>
		</div>
		<section class="my_account no_banner_page clearfix">
			<div class="tomatos"></div>
			<div class="container">
				<div class="cat_inner row clearfix">
					<side-nav @clicked="sideNavItem" v-bind:state="state" />
					<div
						class="left main_white col-lg-10 col-md-10 col-xs-12"
						v-if="this.$route.name == 'myaccount' || this.$route.name == 'userhome'"
					>
						<h1 class="cat_title">החשבון שלי</h1>
						<div class="clearfix">
							<div class="right check_col">
								<h2 class="check_title">
									פרטים אישיים
									<USERSTROKE />
								</h2>
								<div class="account_fileds" v-if="editAccount">
									<form @submit.prevent="updateAccount" id="updateAccount" novalidate :class="{ loading: loading }">
										<div class="clearfix">
											<div class="right wrap_input">
												<div class="form_tx">
													שם פרטי
													<span class="red">*</span>
												</div>

												<div class="form_input">
													<input
														type="text"
														v-model="name"
														v-validate="'required'"
														name="billing_first_name"
													/>
													<div class="error_tx">{{ errors.first("billing_first_name") }}</div>
												</div>
											</div>
											<div class="left wrap_input">
												<div class="form_tx">
													שם משפחה
													<span class="red">*</span>
												</div>
												<div class="form_input">
													<input
														type="text"
														v-model="lastname"
														v-validate="'required'"
														name="billing_last_name"
													/>
													<div class="error_tx">{{ errors.first("billing_last_name") }}</div>
												</div>
											</div>
										</div>
										<div class="birthday-wrap" v-if="!birthday && !hideBirthday">
											<BirthdayField />
										</div>
										<div class="clearfix" v-if="reg_via == 'website'">
											<div class="form_tx">
												מייל
												<span class="red">*</span>
											</div>
											<div class="form_input">
												<input
													type="text"
													v-model="email"
													v-validate="'required|email'"
													name="billing_email"
												/>
												<div class="error_tx">{{ errors.first("billing_email") }}</div>
											</div>
										</div>
										<div class="clearfix" v-if="reg_via != 'website'">
											<div class="form_tx">
												מייל
												<span class="red">*</span>
											</div>
											<div class="form_input">{{ email }}</div>
										</div>
										<div class="clearfix">
											<div class="form_tx">סיסמה</div>
											<div class="form_input">
												<input type="password" value name="account_password" />
											</div>
										</div>
										<div class="clearfix">
											<div class="right wrap_input">
												<div class="form_tx">
													טלפון
													<span class="red">*</span>
												</div>
												<div class="form_input">
													<input
														type="text"
														v-model="phone"
														v-validate="{
															required: true,
															regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
														}"
														name="billing_phone"
													/>
													<div class="error_tx">{{ errors.first("billing_phone") }}</div>
												</div>
											</div>
											<div class="left wrap_input">
												<div class="form_tx">טלפון נוסף</div>
												<div class="form_input">
													<input
														type="text"
														v-model="phonesec"
														v-validate="{
															regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
														}"
														data-validation="phone"
														name="billing_phonesec"
														key="billing_phonesec"
													/>
													<div class="error_tx" v-if="errors.first('billing_phonesec')">
														{{ errors.first("billing_phonesec") }}
													</div>
												</div>
											</div>
										</div>

										<!-- Company fields -->
										<div class="clearfix">
											<div class="form_tx">
												סוג לקוח
												<span class="red">*</span>
											</div>
											<div class="form_select">
												<Select2
													name="customer_type"
													v-validate="'required'"
													v-model="customer_type"
													key="customer_type"
													:placeholder="'סוג לקוח'"
													:searchable="false"
												>
													<option value="regular" selected>פרטי</option>
													<option value="business">בית עסק</option>
												</Select2>
											</div>
										</div>
										<div class="clearfix" v-if="customer_type === 'business'">
											<div class="right wrap_input">
												<div class="form_tx">
													שם בית העסק
													<span class="red">*</span>
												</div>
												<div class="form_input">
													<input
														type="text"
														v-model="business_name"
														v-validate="{ required: true }"
														name="business_name"
														key="business_name"
													/>
													<div class="error_tx" v-if="errors.first('business_name')">
														{{ errors.first("business_name") }}
													</div>
												</div>
											</div>
											<div class="left wrap_input">
												<div class="form_tx">
													ח.פ / ת.ז
													<span class="red">*</span>
												</div>
												<div class="form_input">
													<input
														type="text"
														v-model="business_tax_id"
														v-validate="{ required: true }"
														name="business_tax_id"
														key="business_tax_id"
													/>
													<div class="error_tx" v-if="errors.first('business_tax_id')">
														{{ errors.first("business_tax_id") }}
													</div>
												</div>
											</div>
										</div>
										<!-- END OF | Company fields -->

										<div class="error_tx" v-if="error">{{ error }}</div>
										<div class="account_btns clearfix">
											<div class="left bt_green ease" :class="{ loading: loading }">
												<a href="javascript:void(0);" @click.prevent="updateAccount"
													>שמירת שינויים</a
												>
											</div>
											<div class="left green_link">
												<a href="#" @click.prevent="cancelInfoUpdate">ביטול</a>
											</div>
										</div>
									</form>
								</div>
								<div class="fields_close" v-if="!editAccount">
									<a href="javascript:void(0)" class="edit_link" @click.prevent="editToggleAccount">
										עריכת פרטים
										<PEN />
									</a>
									<div class="text">
										{{
											this.$store.state.userLoggedInfo.firstname +
											" " +
											this.$store.state.userLoggedInfo.lastname
										}}
										<br />
										{{ this.$store.state.userLoggedInfo.email }}
										<br />
										{{ this.$store.state.userLoggedInfo.phone }}
										<div v-if="this.$store.state.userLoggedInfo.phonesec">
											{{ this.$store.state.userLoggedInfo.phonesec }}
										</div>
										<div v-if="this.$store.state.userLoggedInfo.customer_type === 'business'">
											שם בית עסק: {{ this.$store.state.userLoggedInfo.business_name }}
											<br />
											ח.פ / ת.ז: {{ this.$store.state.userLoggedInfo.business_tax_id }}
										</div>
									</div>
								</div>
							</div>
							<div class="right check_col">
								<h2 class="check_title">
									פרטי משלוח
									<SHIPP />
								</h2>
								<div class="account_fileds" v-if="editAddress">
									<form @submit.prevent="updateAddress" id="adrUpdate" novalidate :class="{ loading: loading }">
										<div class="clearfix">
											<div class="form_tx">
												עיר
												<span class="red">*</span>
											</div>
											<div class="form_select">
												<select2
													name="billing_city"
													v-validate="'required'"
													v-model="address_city"
													key="billing_city"
													:placeholder="'בחר עיר מהרשימה'"
												>
													<option></option>
													<option
														:value="city.city_name"
														v-for="city in $store.state.cities"
														:key="city.id"
													>
														{{ city.city_name }}
													</option>
												</select2>
											</div>
										</div>
										<div class="clearfix">
											<div class="right wrap_input">
												<div class="form_tx">
													רחוב
													<span class="red">*</span>
												</div>
												<div class="form_input">
													<vue-simple-suggest
														ref="streets"
														preventHide="true"
														v-model="address_street"
														:list="getStreets"
														:class="{ proccessing: loadingStreets }"
														mode="input"
														:debounce="500"
														value-attribute="name"
														:min-length="1"
														autocomplete="off"
														:controls="{
															selectionUp: [38],
															selectionDown: [40],
														}"
														display-attribute="name"
														:prevent-submit="true"
														:destyled="true"
														v-validate="{ required: true }"
														name="billing_address_street"
														key="billing_address_street"
														@select="onAddressSelect"
													>
														<input
															type="text"
															:value="address_street"
															autocomplete="off"
															v-validate="{ required: true }"
															name="billing_address_street"
															key="billing_address_street"
															@blur="checkAddress"
														/>
														<div
															slot="suggestion-item"
															slot-scope="{ suggestion }"
															class="custom"
														>
															<div class="clearfix">
																<span class="right autoc_tx">
																	<span
																		class="pr_title street_name_label"
																		v-html="suggestion.label"
																	></span>
																	<button
																		@click="addCityInput()"
																		class="small_rounded_button"
																		v-if="suggestion.value == 'addstreet'"
																	>
																		+
																	</button>
																</span>
															</div>
														</div>
													</vue-simple-suggest>
													<div class="error_tx" v-if="errors.first('billing_address_street')">
														{{ errors.first("billing_address_street") }}
													</div>
													<div class="error-not-from-list" v-if="showAdressError">
														כדי שנגיע אליכם הכי מהר שאפשר מומלץ לבחור כתובת מהרשימה...
													</div>
												</div>
											</div>
											<div class="left wrap_input">
												<div class="form_tx">בית<span class="red">*</span></div>
												<div class="form_input">
													<input
														type="text"
														v-model="address_house"
														v-validate="'required'"
														name="billing_address_house"
														key="billing_address_house"
													/>

													<div class="error_tx" v-if="errors.first('billing_address_house')">
														{{ errors.first("billing_address_house") }}
													</div>
												</div>
											</div>
										</div>
										<div class="clearfix">
											<div class="right small_input">
												<div class="form_tx">דירה <span class="red">*</span></div>
												<div class="form_input">
													<input
														type="text"
														v-model="address_apart"
														name="billing_address_apart"
														key="billing_address_apart"
														v-validate="'required'"
													/>
													<div class="error_tx" v-if="errors.first('billing_address_apart')">
														{{ errors.first("billing_address_apart") }}
													</div>
												</div>
											</div>
											<div class="right small_input">
												<div class="form_tx">קומה <span class="red">*</span></div>
												<div class="form_input">
													<input
														type="text"
														v-model="address_floor"
														name="billing_address_floor"
														key="billing_address_floor"
														v-validate="'required'"
													/>
													<div class="error_tx" v-if="errors.first('billing_address_floor')">
														{{ errors.first("billing_address_floor") }}
													</div>
												</div>
											</div>
											<div class="right small_input">
												<div class="form_tx">קוד כניסה</div>
												<div class="form_input">
													<input
														type="text"
														v-model="address_code"
														name="billing_address_code"
													/>
												</div>
											</div>
										</div>
										<div class="error_tx" v-if="errorAddress">{{ errorAddress }}</div>
										<div class="clearfix">
											<div class="form_check">
												<label class="form_check_tx">
													אני רוצה לקבל עדכונים על מבצעים, טיפים מעולים לבישול והפתעות עונתיות
													במייל וב-sms
													<input
														type="checkbox"
														name="subscribe"
														v-model="subscribe"
														value="אני רוצה לקבל עדכונים על מבצעים, טיפים מעולים לבישול והפתעות עונתיות במייל וב-sms"
													/>
													<span class="checkmark"></span>
												</label>
												<!-- <div class="small_note" v-if="!subscribe">
                          על מנת שנוכל לתת לך שירות ברמה גבוהה, נמשיך לשלוח לך הודעות שירות
                          בנושא המשלוח עצמו בלבד. לפרטים בנושא ניתן לדבר איתנו
                          <a-div
                            :href="wpData.globalOptions.customer_service_link.url.replace(wpData.home_url,'')"
                          >כאן</a-div>
                        </div> -->
											</div>
										</div>
										<div class="account_btns clearfix">
											<div class="left bt_green ease" :class="{ loading: loading }">
												<a href="javascript:void(0);" @click.prevent="updateAddress"
													>שמירת שינויים</a
												>
											</div>
											<div class="left green_link">
												<a href="#" @click.prevent="cancelAddressUpdate">ביטול</a>
											</div>
										</div>
									</form>
								</div>
								<div class="fields_close" v-if="!editAddress">
									<a href="javascript:void(0)" class="edit_link" @click.prevent="editToggleAddress">
										עריכת פרטים
										<PEN />
									</a>
									<div class="text" v-html="addressTxt"></div>
								</div>
							</div>
						</div>
					</div>
					<router-view></router-view>
					<!-- <favorites v-if="state == 'favorites'" />
          <order-history v-if="state == 'history'" />
          <permanent-order v-if="state == 'order'" />-->
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapGetters } from "vuex";
	import SideNav from "../components/MyAccount/sideNav";
	import Select2 from "../components/Select2";
	import Favorites from "../components/MyAccount/Favorites";
	import OrderHistory from "../components/MyAccount/OrderHistory";
	import PermanentOrder from "../components/MyAccount/PermenantOrder.vue";
	import store from "../store";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import USERSTROKE from "../assets/img/user-stroke.svg";
	import PEN from "../assets/img/pen.svg";
	import SHIPP from "../assets/img/shipp.svg";
	import ARROWL from "../assets/img/arrow_l.svg";
	import AccountSvg from "../assets/img/account.svg";
	import LogOutSvg from "../assets/img/logout.svg";
	import BirthdayField from "@/components/Checkout/BirthdayField.vue";

	export default {
		data() {
			return {
				state: "main",
				add_city: false,
				editAccount: false,
				editAddress: false,
				loadingStreets: false,
				assets: this.$wpData.assets_url,
				name: this.$store.state.userLoggedInfo.firstname,
				lastname: this.$store.state.userLoggedInfo.lastname,
				email: this.$store.state.userLoggedInfo.email,
				phone: this.$store.state.userLoggedInfo.phone,
				phonesec: this.$store.state.userLoggedInfo.phonesec,
				reg_via: this.$store.state.userLoggedInfo.regvia,
				address_city: this.$store.state.userLoggedInfo.city,
				address_street: this.$store.state.userLoggedInfo.street,
				address_house: this.$store.state.userLoggedInfo.house,
				address_floor: this.$store.state.userLoggedInfo.floor,
				address_apart: this.$store.state.userLoggedInfo.apart,
				address_code: this.$store.state.userLoggedInfo.code,
				subscribe: parseInt(this.$store.state.userLoggedInfo.subscribed),
				birthday: this.$store.state.userLoggedInfo.birthday,
				hideBirthday: false,

				loading: false,
				error: "",
				errorAddress: "",
				wpData: wpData,
				globalOption: wpData.globalOptions,

				// Company
				customer_type: this.$store.state.userLoggedInfo.customer_type
					? this.$store.state.userLoggedInfo.customer_type
					: "regular",
				business_name: this.$store.state.userLoggedInfo.business_name
					? this.$store.state.userLoggedInfo.business_name
					: "",
				business_tax_id: this.$store.state.userLoggedInfo.business_tax_id
					? this.$store.state.userLoggedInfo.business_tax_id
					: "",

				address: "",
				cityLatLng: false,
				cityBounds: false,
				showAdressError: false,
				cashback: this.$store.state.cashback,
			};
		},
		computed: {
			...mapGetters(["getLogoutText"]),
			addressTxt() {
				var str = this.address_street + " " + this.address_house + "<br />" + this.address_city;
				if (this.address_floor) {
					str = str + "<br />" + "קומה " + this.address_floor;
				}
				if (this.address_apart) {
					str = str + ", דירה " + this.address_apart;
				}
				if (this.address_code) {
					str = str + "<br />" + "קוד " + this.address_code;
				}
				return str;
			},
		},
		watch: {
			address_city: function (value) {
				if (this.editAddress) {
					this.$store.commit("setCity", value);
					this.address_street = "";
					this.address_house = "";
					this.address_apart = "";
				}

				this.googleAPI_city();
			},
		},
		mounted() {
			if (this.$route.params.fav === "favorites") {
				this.state = "favorites";
			}
			if (this.$route.params.fav === "history") {
				this.state = "history";
			}
		},
		methods: {
			...mapActions(["userLogout"]),
			cancelAddressUpdate() {
				this.editAddress = false;
				this.address_city = this.$store.state.userLoggedInfo.city;
				this.address_street = this.$store.state.userLoggedInfo.street;
				this.address_house = this.$store.state.userLoggedInfo.house;
				this.address_floor = this.$store.state.userLoggedInfo.floor;
				this.address_apart = this.$store.state.userLoggedInfo.apart;
				this.address_code = this.$store.state.userLoggedInfo.code;
				this.subscribe = this.$store.state.userLoggedInfo.subscribed;
			},
			cancelInfoUpdate() {
				this.editAccount = false;
				this.name = this.$store.state.userLoggedInfo.firstname;
				this.lastname = this.$store.state.userLoggedInfo.lastname;
				this.email = this.$store.state.userLoggedInfo.email;
				this.phone = this.$store.state.userLoggedInfo.phone;
				this.phonesec = this.$store.state.userLoggedInfo.phonesec;
			},
			checkAddress(e) {
				this.showAdressError = false;
				if (this.address_city !== "איסוף עצמי" && e.target.value !== "" && e.target.value !== this.address) {
					this.showAdressError = true;
				}
			},
			googleAPI_city() {
				const service = new google.maps.Geocoder();
				service.geocode(
					{
						address: this.address_city,
					},
					(results, status) => {
						if (status !== "OK") {
							console.log("Geocode was not successful for the following reason: " + status);
						}
						console.log(results[0]);
						this.cityLatLng = results[0].geometry.location;
						this.cityBounds = results[0].geometry.bounds;
					}
				);
			},
			googleAPI_streets() {
				const service = new google.maps.places.AutocompleteService();
				return new Promise((resolve, reject) => {
					service.getPlacePredictions(
						{
							input: this.address_city + ", " + this.address_street,
							componentRestrictions: {
								country: "il",
							},
							bounds: this.cityBounds,
							// location: this.cityLatLng,
							// radius: 10,
							types: ["route"],
						},
						(predictions, status) => {
							if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
								reject();
							}
							resolve(predictions);
						}
					);
				});
			},
			getStreets() {
				return new Promise((resolve, reject) => {
					this.loadingStreets = true;
					let shipping = false;
					if (this.showOtherAddress) {
						shipping = true;
					}
					this.add_city = false;

					this.googleAPI_streets()
						.then((streets) => {
							console.log("streets: ", streets);
							this.loadingStreets = false;
							let output = [];

							streets.forEach((value) => {
								//if (typeof value.terms[1] !== 'undefined' && value.terms[1].value.includes(this.address_city)) {
								if (
									typeof value.structured_formatting.secondary_text !== "undefined" &&
									value.structured_formatting.secondary_text.includes(this.address_city)
								) {
									// console.log(value.structured_formatting.secondary_text);
									// console.log(this.address_city);

									output.push({
										name: value.structured_formatting.main_text,
										label: value.structured_formatting.main_text,
										value: value.structured_formatting.main_text,
									});
								}
							});
							resolve(output);
						})
						.catch(() => {
							this.loadingStreets = false;
							console.log("no results");
							reject();
						});

					// if (streets.length == 1 && streets[0].value == "addstreet") {
					//   streets[0].name = shipping ? this.shipping_street : this.address_street;
					// }
				});
			},
			getStreets2() {
				return new Promise((resolve, reject) => {
					this.loadingStreets = true;
					this.$ajax({
						method: "POST",
						//url: ajaxUrl,
						url: homeUrl + "street_ajax.php",
						params: {
							// action: "findStreet",
							findStreet: "findStreet",
							term: this.address_street,
							city: this.address_city,
						},
					})
						.then((res) => {
							let streets = res.data;
							if (streets[0].value == "addstreet") {
								streets[0].name = this.address_street;
							}
							this.loadingStreets = false;
							resolve(streets);
						})
						.catch((e) => {
							reject(e);
						});
				});
			},
			sideNavItem(data) {
				this.state = data;
			},
			editToggleAccount() {
				this.editAccount = !this.editAccount;
			},
			onAddressSelect(value) {
				if (value.value == "addstreet") {
					value.value = this.address_street;
					// console.log(this.address_street);
					return;
				}
				this.address = value.value;
				this.showAdressError = false;
			},
			editToggleAddress() {
				this.editAddress = !this.editAddress;
			},
			addCityInput() {
				//console.log("add city input");
				this.add_city = false;
				this.$refs.streets.hideList();
			},
			updateAddress() {
				this.$validator.validate().then((result) => {
					if (result) {
						this.loading = true;
						var form = document.querySelector("#adrUpdate");
						let data = new FormData(form);
						this.$ajax.post("?sendUpdateAccountAddress", data).then((response) => {
							//this.$ajax.get(ajaxUrl + "?action=isUserLogged").then(resposne => {
							if (response.data.success == "false") {
								this.errorAddress = response.data.errorText;
								// console.log("1");
								this.loading = false;
								return;
							}
							if (response.data.success == "true") {
								store.commit("setUserInfo", response.data.userInfo);
								//console.log("2");

								this.editToggleAddress();
								this.editAddress = false;
								this.loading = false;
							}
							if (!response.data.success) {
								store.commit("clearUser");
								this.loading = false;
							}
							//});
						});
					}
				});
			},
			updateAccount() {
				this.$validator.validate().then((result) => {
					if (result) {
						this.loading = true;
						var form = document.querySelector("#updateAccount");
						let data = new FormData(form);
						this.$ajax.post(homeUrl + "?sendUpdateAccountInfo", data).then((response) => {
							//this.$ajax.get(ajaxUrl + "?action=isUserLogged").then(resposne => {
							if (response.data.success == "false") {
								this.error = response.data.errorText;
								this.loading = false;
								return;
							}
							if (response.data.success == "true") {
								store.commit("setUserInfo", response.data.userInfo);
								this.loading = false;
								this.editToggleAccount();
								this.hideBirthday = true;
							}
							if (!response.data.success) {
								this.loading = false;
								store.commit("clearUser");
							}
							//});
						});
					}
				});
			},
		},
		components: {
			BirthdayField,
			SideNav,
			USERSTROKE,
			PEN,
			SHIPP,
			Select2,
			Favorites,
			OrderHistory,
			VueSimpleSuggest,
			PermanentOrder,
			ARROWL,
			AccountSvg,
			LogOutSvg,
		},
	};
</script>
<style scoped>
	.autoc_tx {
		width: 100%;
	}
	.form_select a.select2-choice {
		color: black !important;
	}
	.small_rounded_button {
		background-color: #213519;
		border: 0;
		color: #fff;
		border-radius: 50%;
		margin-right: 20px;
		vertical-align: middle;
		text-align: center;
		display: inline-block;
		width: 25px;
		height: 22px;
		position: absolute;
		left: 0;
		top: 0;
		transform: translate(10px, 10px);
	}
	.misc-item {
		padding: 9px;
	}
	.error-not-from-list {
		font-size: 12px;
		text-align: right;
		color: #ea4724;
	}
	.birthday-wrap {
		border: 1px solid #c2bfb6;
		border-width: 1px 0;
		padding: 1em 0;
		margin: 1em 0 1.5em;
	}
	@media (max-width: 480px) {
		.left.main_white > .clearfix {
			background: #fff;
			padding: 20px 20px 0;
		}

		.check_title + div {
			padding-top: 10px;
		}
	}
</style>
